import { render, staticRenderFns } from "./OnlinePayments.vue?vue&type=template&id=39f881d9&scoped=true&"
import script from "./OnlinePayments.vue?vue&type=script&lang=js&"
export * from "./OnlinePayments.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePayments.vue?vue&type=style&index=0&id=39f881d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f881d9",
  null
  
)

export default component.exports